import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'
import React, { useEffect } from 'react'

const buildOptionValue = (option) => option?.value ?? option?.name
const buildTooltipTitle = (option) => (
  <div className="knockout-tooltip">
    {option.sourceLabel ? <div className="knockout-tooltip-line">{option.sourceLabel}</div> : null}
    <div className="knockout-tooltip-line">
      {option.name}{option.rank ? ` - Rank ${option.rank}` : ''}
    </div>
  </div>
)

export default function KnockoutMatchupV2({ bracket, championship, field, label, onChange, options, readonly = false, showSelection = true, getReadonlyOutcome }) {
  const selectedValue = bracket[field]

  useEffect(() => {
    if (selectedValue && options.every(option => buildOptionValue(option) !== selectedValue)) {
      onChange(undefined, field)
    }
  }, [field, onChange, options, selectedValue])

  const handleSelection = (value) => {
    if (readonly) return
    onChange(selectedValue === value ? undefined : value, field)
  }

  const buildReadonlyOutcome = (option) => {
    const optionValue = buildOptionValue(option)
    if (!readonly || !getReadonlyOutcome) return null

    if (option?.thirdPlaceParticipant) {
      return getReadonlyOutcome(field, optionValue, option)
    }

    const sourceField = option?.sourceField ?? field
    return getReadonlyOutcome(sourceField, optionValue, option)
  }

  return (
    <ul className={`matchup matchup-v2 ${championship ? 'championship current' : ''}`}>
      <div className="matchup-v2-label wc-quaternary">{label}</div>
      {[0, 1].map((idx) => {
        const option = options[idx]
        if (!option) {
          return (
            <li className="team team-form team-top" key={`${field}-empty-${idx}`}>
              <button className="team-pick-button team-pick-button-empty" disabled type="button">
                <span className="team-pick-placeholder" aria-hidden="true">&nbsp;</span>
              </button>
            </li>
          )
        }

        const optionValue = buildOptionValue(option)
        const isSelected = optionValue === selectedValue && (showSelection || readonly)
        const readonlyOutcome = buildReadonlyOutcome(option)
        const readonlyClass = readonlyOutcome?.state ? `team-pick-button-${readonlyOutcome.state}` : ''

        return (
          <li className="team team-form team-top" key={optionValue}>
            <Tooltip
              placement="top"
              title={buildTooltipTitle(option)}
            >
              <span className="team-pick-tooltip-trigger">
                <button
                  aria-label={`Select ${option.name}`}
                  className={`team-pick-button ${isSelected ? 'selected' : ''} ${readonlyClass}`.trim()}
                  onClick={() => handleSelection(optionValue)}
                  disabled={readonly}
                  type="button"
                >
                  <span className="team-pick-main">
                    <img className="inline-flag" src={option.flag} alt="flag" />
                    <span className="wc-secondary">{optionValue}</span>
                  </span>
                  <span className="team-pick-meta">
                    {readonlyOutcome?.display ? (
                      <span className={`team-pick-status team-pick-status-${readonlyOutcome.state}`}>
                        {readonlyOutcome.display}
                      </span>
                    ) : null}
                    {isSelected && !readonly ? (
                      <span className="group-selection" aria-label="Selected">
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    ) : null}
                  </span>
                </button>
              </span>
            </Tooltip>
          </li>
        )
      })}
    </ul>
  )
}
